<mat-drawer-container class="drawer-container" [dir]="direction">
  @if (currentLayout === 'vertical') {
  <mat-drawer #sidebar class="pc-sidebar" [mode]="modeValue" opened>
    <nav>
      <div class="navbar-wrapper">
        <div class="m-header">
          <a href="/">
            <img src="../../../../assets/images/Tab-Logo.png" alt="logo" />
            <span class="version"> v{{ currentApplicationVersion }} </span>
          </a>
        </div>

        <app-vertical-menu [menus]="menus"></app-vertical-menu>
      </div>
    </nav>
  </mat-drawer>
  }

  <div>
    <app-nav-bar [ngClass]="{
        'horizontal-navbar': currentLayout === 'horizontal'
      }"></app-nav-bar>
    @if (currentLayout === 'horizontal') {
    <app-horizontal-menu [menus]="menus" [ngClass]="{
          'horizontal-menu': currentLayout === 'horizontal'
        }"></app-horizontal-menu>
    }
    <div class="app-container">
      <app-breadcrumb [dashboard]="true"></app-breadcrumb>
      <div class="main-body">
        <div class="page-wrapper">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</mat-drawer-container>
<app-configuration></app-configuration>